/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_DelayedInputs */

const en_tasks_status_delayed = /** @type {(inputs: Tasks_Status_DelayedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delayed`)
};

const fr_tasks_status_delayed = /** @type {(inputs: Tasks_Status_DelayedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retardée`)
};

const ms_sg2_tasks_status_delayed = /** @type {(inputs: Tasks_Status_DelayedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tertangguh`)
};

/**
* | output |
* | --- |
* | "Delayed" |
*
* @param {Tasks_Status_DelayedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_delayed = /** @type {((inputs?: Tasks_Status_DelayedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_DelayedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_delayed(inputs)
	if (locale === "fr") return fr_tasks_status_delayed(inputs)
	return ms_sg2_tasks_status_delayed(inputs)
});